import {
  CREATE_DRIVER,
  DRIVER_ACTIVE,
  DRIVER_DEACTIVE,
  DRIVER_PROFILE,
  GET_DRIVERS_LIST,
  GET_DRIVER_LEAVES_LIST,
  GET_OTHER_PHOTOS_LIST,
  GET_TRANSPORTATION_ALLOWANCE_LIST,
  UPDATE_DRIVER,
} from "../actions/DriverActions";

const initialState = {// initialize states
  drivers: [],
  driverData: "",
  transporatationAllowance: [],
  otherPhotos: [],
  driverLeaves: [],
};

const DriversReducer = function (state = initialState, action) {
  switch (action.type) {
    case GET_DRIVERS_LIST: { //save driver list data into state
      return {
        ...state,
        drivers: action.payload.data ? action.payload.data : [],
      };
    }
    case CREATE_DRIVER: {
      return { ...state };
    }
    case DRIVER_ACTIVE: {
      return { ...state };
    }
    case DRIVER_DEACTIVE: {
      return { ...state };
    }
    case DRIVER_PROFILE: { // save driver profile data into state
      return {
        ...state,
        driverData: action.payload.data ? action.payload.data : "",
      };
    }
    case UPDATE_DRIVER: {
      return { ...state };
    }
    case GET_TRANSPORTATION_ALLOWANCE_LIST: { // save transportation allowance data into state
      return {
        ...state,
        transporatationAllowance: action.payload.data
          ? action.payload.data
          : [],
      };
    }
    case GET_OTHER_PHOTOS_LIST: { // save other photo data into state
      return {
        ...state,
        otherPhotos: action.payload.data ? action.payload.data : [],
      };
    }
    case GET_DRIVER_LEAVES_LIST: { // save driver leave data into state
      return {
        ...state,
        driverLeaves: action.payload.data ? action.payload.data : [],
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default DriversReducer;
